import { z } from "zod";
import { AgencyIdSchema, ProjectIdSchema } from "../primitives/ids.js";
export const ClientAnalyticsIssueKindSchema = z.enum([
    "LOW_ENGAGEMENT",
    "FORM_DROP",
    "CALL_MISSED_OPPORTUNITY",
]);
export const ClientAnalyticsSummaryV1Schema = z
    .object({
    schemaVersion: z.literal("client-analytics-summary.v1.0"),
    agencyId: AgencyIdSchema,
    projectId: ProjectIdSchema,
    periodDays: z.number().int().positive(),
    outcomes: z.object({
        totalEvents: z.number().int().nonnegative(),
        formSubmits: z.number().int().nonnegative(),
        callClicks: z.number().int().nonnegative(),
    }),
    topPages: z.array(z.object({
        pagePath: z.string(),
        viewCount: z.number().int().nonnegative(),
    })),
    issues: z.array(z.object({
        kind: ClientAnalyticsIssueKindSchema,
        summary: z.string(),
    })),
    changeHistory: z.array(z.object({
        changedAt: z.string().datetime(),
        summary: z.string(),
    })),
    generatedAt: z.string().datetime(),
})
    .strict();
//# sourceMappingURL=care-client-analytics.js.map